import styled from "styled-components";
import { Panel, Badge, Nav } from "react-bootstrap";

export const ActionCenterNavWrapper = styled.div`
    padding-left: 20px;
    
    & > ul > li.active > a {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

    margin-bottom: 5px;
`;

export const PanelHeadingWrapper = styled(Panel.Heading)`
    margin-top: 0px;
    margin-bottom: 0px;

    @media (max-width: 1823px) {
        font-size: 12px;
    }
`;

export const ToDoItemRowWrapper = styled.div`
    margin-top: 5px;
    margin-bottom: 5px;
`;

interface IToDoItemDescriptionWrapper {
    isDisabled: boolean
}

export const ToDoItemDescriptionWrapper = styled.div<IToDoItemDescriptionWrapper>`
    color: ${(props: IToDoItemDescriptionWrapper) => props.isDisabled ? '#ccc' : 'initial'};
    flex-basis: 97%;
    font-size: 16px;

    :hover {
        cursor: pointer;
    }

    @media (max-width: 1823px) {
        font-size: 12px;
    }
`;

export const ToDoColumnWrapper = styled.div`
    margin-left: -15px;
    margin-right: -15px;
    margin-top: 5px;
    margin-bottom: 5px;
`;

export const BadgeWrapper = styled(Badge)`
    width: 30px;
    height: 28px;
    padding: 7px 0px 7px 0px;
    font-size: 14px;

    @media (max-width: 1823px) {
        width: 26px;
        height: 24px;
        font-size: 12px;
        padding: 5px 0px 5px 0px;
    }
`;

export const BadgeWrapperForNonList = styled(Badge)`
    width: 30px;
    height: 28px;
    padding: 5px 0px 7px 0px;
    font-size: 14px;

    @media (max-width: 1823px) {
        width: 26px;
        height: 24px;
        font-size: 12px;
        padding: 5px 0px 5px 0px;
    }
`;

interface INavWrapperProps {
    verticalAlign?: string,
    minTabWidth?: string,
    height?: string,
    backgroundColor?: string
}

export const NavWrapper = styled(Nav) <INavWrapperProps>`
    & > li {
        height: ${(p: INavWrapperProps) => p.height ? p.height : '52px'};
    }

    & > li > a {
        font-size: 14px;
        font-weight: 500;
        background-color: ${(p: INavWrapperProps) => p.backgroundColor ? p.backgroundColor : '#337ab7'};
        color: white;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: ${(p: INavWrapperProps) => p.verticalAlign ? p.verticalAlign : 'flex-end'};
        min-width: ${(p: INavWrapperProps) => p.minTabWidth ? p.minTabWidth + 'px !important' : '0px'};
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            // font-size: 12px;
            min-width: 120px;
        }
    }
`;
